import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 課程活動 列表頁
  {
    path: '/event',
    name: 'event-list',
    component: () => lazyLoadView(import('@views/Event/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brand, city } = await store.dispatch('category/fetchCategroy', {
            types: ['brand', 'city'],
            pageAlias: 'event'
          });
          routeTo.params.brandOptions = brand;
          routeTo.params.cityOptions = city.length ? city.map((item)=> {
            return {
              name: item
            }
          }) : [];
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "event",
      title: '課程活動列表'
    },
    props: (route) => ({
      brandOptions: route.params.brandOptions || [],
      cityOptions: route.params.cityOptions || [],
    })
  },
  // 代理品牌 課程活動 列表頁
  {
    path: '/product/brand/:brandAlias/event',
    name: 'brand-event-list',
    component: () => lazyLoadView(import('@views/Brand/Event/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('brand/fetchBrand', {
            brandAlias: routeTo.params.brandAlias
          })
          const tabs = store.state.brand.cachedBrand.tabs
          const result = tabs.some((item) => {
            return item.alias === 'event'
          })
          if(!result) return next({ name: '404' })
          // await Promise.all([
          //   store.dispatch('option/fetchOptionList', {
          //     types: ['brand'],
          //     useCached: true
          //   })
          // ]);
          const { city } = await store.dispatch('category/fetchCategroy', {
            types: ['city'],
            pageAlias: 'event',
            brand_alias: routeTo.params.brandAlias
          });
          routeTo.params.cityOptions = city.length ? city.map((item)=> {
            return {
              name: item
            }
          }) : [];
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '代理品牌-課程活動列表'
    },
    props: (route) => ({
      cityOptions: route.params.cityOptions || [],
    })
  },
  // 代理品牌 課程活動 內容頁
  {
    path: '/product/brand/:brandAlias/event/:eventAlias/:eventSeriesNum',
    name: 'brand-event-item',
    component: () => import('@views/Brand/Event/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            }),
          ]);

          const [
            currentEventItem
          ] = await Promise.all([
            store.dispatch('event/fetchEventItem', {
              eventAlias: routeTo.params.eventAlias,
              seriesNum: routeTo.params.eventSeriesNum,
            }),
          ]);

          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
          // routeTo.params.breadcrumbTitle = currentEventItem.items.title;
          routeTo.params.defaultValue = currentEventItem.items;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "brand",
      title: '課程活動'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue || {},
    })
  },

  // 課程活動 內容頁
  // {
  //   path: '/event/:eventAlias/:eventSeriesNum',
  //   name: 'event-item',
  //   component: () => import('@views/Brand/Event/Item'),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const [
  //           currentEventItem
  //         ] = await Promise.all([
  //           store.dispatch('event/fetchEventItem', {
  //             eventAlias: routeTo.params.eventAlias,
  //             seriesNum: routeTo.params.eventSeriesNum,
  //           }),
  //         ]);
  //         await Promise.all([
  //           store.dispatch('brand/fetchBrand', {
  //             brandAlias: currentEventItem.items.brands[0].alias
  //           }),
  //         ])
  //         routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
  //         // routeTo.params.breadcrumbTitle = currentEventItem.items.title;
  //         routeTo.params.defaultValue = currentEventItem.items;

  //         next()
  //       } catch(error) {
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     },
  //   },
  //   props: (route) => ({
  //     defaultValue: route.params.defaultValue || {},
  //   })
  // },
]